import {
    Button,
} from "@material-ui/core";
import { useState } from "react";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { bulkActionsStyle } from "../Flags/style";
import {OverrideInspectionReadinessDialog} from "./OverrideInspectionReadinessDialog";

export const OverrideInspectionReadiness = ({
    selectedRows,
    reloadReadiness
}) => {
    const classes = bulkActionsStyle();
    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    }

    return (
        <>
            <Button onClick={onOpen} className={classes.button}>
                <div>
                    <div>
                        <CheckCircle className="icon" style={{ color: "#0090fe" }}/>
                    </div>
                    <div>Override Inspection Readiness</div>
                </div>
            </Button>
            {open && <OverrideInspectionReadinessDialog
                setOpen={setOpen}
                open={open}
                selectedRows={selectedRows}
                reloadReadiness={reloadReadiness}
            />}
        </>
    );
}